export default "<span class=\"key-help\" *ngIf=\"key&&text\" [innerHtml]=\"text\"></span>\r\n";